<template><svg width="549px" height="540px" viewBox="0 0 549 540" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>plus</title>
    <g id="plus" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M311,52 L310.999,233.499 L492.5,233.5 L492.5,306.5 L310.999,306.499 L311,488 L238,488 L237.999,306.499 L56.5,306.5 L56.5,233.5 L237.999,233.499 L238,52 L311,52 Z" id="Combined-Shape" fill="#767676"></path>
    </g>
</svg></template>